import { Language } from '../Domain/Account/Language';

// Maintains the in-memory campaign context for compact campaign landing pages.
// Since this module never touches persistent storage, the values reset whenever
// the app reloads; consumers should treat this as ephemeral UI state.

let activeCampaignCode: string | null = null;
let languageOverride: Language | null = null;

// Persists the current campaign code (lowercased) and optional language override
// so the hosting page can pick the correct assets/translations without passing
// the values through every component prop chain.
export const setCampaignContext = (code: string | null, defaultLanguage?: Language | null) => {
	activeCampaignCode = typeof code === 'string' && code.trim().length > 0 ? code.trim().toLowerCase() : null;
	languageOverride = defaultLanguage ?? null;
};

// Returns the last campaign code stored via setCampaignContext (or null if none).
export const getActiveCampaignCode = (): string | null => activeCampaignCode;

// Returns the language override associated with the active campaign, if any.
export const getCampaignLanguageOverride = (): Language | null => languageOverride;


